import checkIfBrowser from '../../env/is-browser';
export { self, window, global, document, process, console } from '../../env/globals';
export var VERSION = typeof "2.0.1" !== 'undefined' ? "2.0.1" : 'untranspiled source';
export var isBrowser = checkIfBrowser();
//# sourceMappingURL=globals.js.map


//////////////////
// WEBPACK FOOTER
// ./~/probe.gl/dist/esm/lib/utils/globals.js
// module id = 116
// module chunks = 0